import React, { useState } from "react";
import { useParams } from "react-router-dom";
import parse from "html-react-parser";

//CSS
import "./ChapterDetailComp.css";
import "bootstrap/dist/css/bootstrap.min.css";

//Components
import Chapter from "../Chapter/Chapter";

//Bootstrap
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

function ChapterDetailComp({ charFound }) {
  const bgImage = charFound.url;

  return (
    <>
      <Row>
        <Col className="chapters-text order-2 order-md-1" lg={7}>
          <div className="scroll-gradient"></div>
          <Col className="text-wrapper">
            <Col
              className="chapters-img d-md-none d-block mb-4"
              style={{ backgroundImage: `url(${bgImage})` }}
              lg={5}
            ></Col>
            <Chapter charFound={charFound} />
          </Col>
        </Col>
        <Col
          className="chapters-img d-md-block d-none order-1 order-md-2"
          style={{ backgroundImage: `url(${bgImage})` }}
          lg={5}
        ></Col>
      </Row>
    </>
  );
}

export default ChapterDetailComp;
